<template>
   <div>
      <div v-show="!locked || parseInt(credits) != 0">
         <div v-if="data.connector === 'OR' && data.order != '0'" class="str-connector">
            <span v-if="!locked"> {{ data.connector }} </span>
         </div>
         <div :class=" !containsUnits ? 'str-container' : 'str-container-no-border'">
            <div :class="depth > 1 ? 'indent' : ''">
               <span v-if="data.title" class="str-title-creds">
                  <span class="str-title">
                     {{ data.title }}
                  </span>
                  <span v-if="depth > 1 || !sortedContainer.length" :class="credits < data.credits || credits > data.credits ? 'str-cred-error str-creds' : 'str-cred-success str-creds'">
                     Required Credits
                     {{ credits }} / {{ data.credits }}
                  </span>
               </span>
               <div v-if="data.description && !locked" class="str-description"> {{ data.description }} </div>
               <!-- <span v-if="credits >= data.credits"> *complete*</span> -->

               <div  v-if="mandatoryRelationships.length" class="str-rels">
                  <Relationship v-for="mr in mandatoryRelationships" :key="mr.code+'-'+mr.order" :data="mr" :location="location+'>'+mr.code+'-'+mr.order" @creditUpdate="updateCredits"/>
               </div>
               <div  v-if="optionalRelationships.length" class="str-rels">
                  <OptionalRelationship :data="optionalRelationships" :requiredCredits="parseInt(data.credits)" :location="location" @creditUpdate="updateCredits" />
               </div>
               <div  v-if="mandatoryConditionSets.length" class="str-rels">
                  <ConditionSet v-for="mc in mandatoryConditionSets" :key="mc.description" :data="mc" :requiredCredits="parseInt(data.credits)" :depth="depth + 1" :location="location"  @creditUpdate="updateCredits"/>
               </div>
               <div  v-if="optionConditionSets.length" class="str-rels">
                  <ConditionSet v-for="oc in optionConditionSets" :key="oc.description" :data="oc"  :depth="depth + 1" :location="location" @creditUpdate="updateCredits"/>
               </div>
               <div  v-if="mandatoryContainers.length" class="str-rels">
                  <Container v-for="mc in mandatoryContainers" :key="mc.title+'-'+mc.order" :data="mc"  :optional="optional" :depth="depth + 1" :location="location+'>'+mc.title+'-'+mc.order" @creditUpdate="updateCredits" />
               </div>
               <div  v-if="optionalContainers.length" class="str-rels">
                  <Container v-for="oc in optionalContainers" :key="oc.title+'-'+oc.order" :data="oc"  :optional="true" :depth="depth + 1" :location="location+'>'+oc.title+'-'+oc.order" @creditUpdate="updateCredits"/>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
   import { mapState, mapActions } from 'vuex'

   import Relationship from './relationship.vue'
   import OptionalRelationship from './optionalRelationship.vue'
   import ConditionSet from './conditionSet.vue'
   import {dynamicSort} from 'common/models/sorting.js'

   export default {
      name: "Container",
      data: function(){
         return {
            credits: 0,
         }
      },
      created: function(){
         if(!this.optional){
            for(var mr of this.mandatoryRelationships){
               if(mr.type === "Unit"){
                  mr.location = this.location+'>'+mr.code+'-'+mr.order
                  this.addSelectedItem(mr);
               }
            }
         }
      },
      components: {
         Relationship,
         OptionalRelationship,
         ConditionSet
      },
      props: {
         data: {
            type: Object,
            required: true,
         },
         depth: {
            type: Number,
            required: true,
         },
         location: {
            type: String,
            required: false,
         },
         optional: {
            type: Boolean,
            required: false,
            default: false,
         }
      },
      computed: {
         ...mapState({
            selectedItems: state => state.selections.selectedItems,
            locked: state => state.selections.locked,
         }),
         sortedContainer: function(){
            return this.data.container.sort( dynamicSort("order") );
         },
         optionalContainers: function(){
            return this.sortedContainer.filter(x => x.connector === "OR");
         },
         mandatoryContainers: function(){
            return this.sortedContainer.filter(x => x.connector === "AND");
         },
         sortedRelationship: function(){
            return this.data.relationship.sort( dynamicSort("order") );
         },
         optionalRelationships: function() {
            return this.sortedRelationship.filter(x => x.connector === "OR");
         },
         mandatoryRelationships: function() {
            return this.sortedRelationship.filter(x => x.connector === "AND");
         },
         optionConditionSets: function() {
            return this.data.conditionSet.filter(x => x.connector === "OR")
         },
         mandatoryConditionSets: function() {
            return this.data.conditionSet.filter(x => x.connector === "AND")
         },
         containerSelectedUnits: function() {
            return this.mandatoryRelationships.filter(x => this.selectedItems.includes(x))
         },
         allSelectedRelationships: function() {
            return this.sortedRelationship.filter(x => this.selectedItems.includes(x))
         },
         containsUnits: function(){
            var flag = false;
            for(var i=0; i<this.sortedRelationship.length; i++){
               if(this.sortedRelationship[i].type == "Unit"){
                  flag = true;
               }
            }
            return flag;
         }
      },
      methods: {
         ...mapActions([
            "addSelectedItem",
         ]),
         updateCredits(c){
            this.credits = this.credits + c;
         },
         addLocation(d){
            d.location = this.location+'>'+d.code+'-'+d.order;
            return d
         }
      },
      watch: {
         credits: function(newVal, oldVal){
            this.$emit('creditUpdate', newVal-oldVal);
         }
      }
   }
</script>

